import { Box, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { CalendarCheck, ExternalLink } from "lucide-react";

import { Button } from "../../../components/Button";
import { useAuth } from "../../../components/contexts/AuthContext";
import { useTheme } from "../../../theme/useTheme";
import { DEMO_BOOKING_URL } from "../../../utils/agencyFeatures";

/** Pinned demo invitation for agency staff while their agency is on trial. */
export function TrialDemoAnnouncement() {
  const { user } = useAuth();
  const { theme } = useTheme();

  if (!user.agencyPlan?.is_trial || !["agency_admin", "consultant"].includes(user.role)) {
    return null;
  }

  const primary = theme.palette.primary.main;

  return (
    <Box
      sx={{
        gridColumn: "1 / -1",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "flex-start", sm: "center" },
        gap: 2,
        p: 2,
        borderRadius: "12px",
        border: `1px solid ${alpha(primary, 0.35)}`,
        borderLeft: `4px solid ${primary}`,
        backgroundColor: alpha(primary, 0.06),
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          width: 44,
          height: 44,
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: primary,
          backgroundColor: alpha(primary, 0.14),
        }}
      >
        <CalendarCheck size={22} />
      </Box>

      <Stack spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, fontSize: "1rem", lineHeight: 1.3 }}>
          ¿Quieres sacarle todo el partido a Markezy?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.4 }}>
          Reserva una demo con Abraham o María y te enseñamos cómo aprovechar tu periodo de
          prueba al máximo: clientes, proyectos, informes y contenidos con IA.
        </Typography>
      </Stack>

      <Button
        size="sm"
        href={DEMO_BOOKING_URL}
        target="_blank"
        rel="noopener noreferrer"
        endIcon={<ExternalLink size={14} />}
        sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
      >
        Reservar demo
      </Button>
    </Box>
  );
}
